import { JsonObj } from '@mhp/general-interface';

export enum ErrorLevel {
  info = 'info',
  warn = 'warn',
  error = 'error'
}
export type ErrorLevelKeys = keyof typeof ErrorLevel;

export interface DfdError extends Error {
  id: string;
  code: number;
  status: string;
  level: ErrorLevelKeys;
  callback?: () => void;
}

export interface ErrorState {
  errors: DfdError[];
}

export interface ErrorAction {
  error?: DfdError;
  id?: string;
  type: string;
  payload?: JsonObj;
}
